/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import { GameAssets } from "../config/texture/GameAssets";
import {PunkRocker2SlideShowPage} from "./PunkRocker2SlideShowPage";


export class PunkRockerIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000, //Default 0x000000
            backgroundAlpha:0.6, //Default 0.4
            bulletColor:0xffffff, //Default 0xffffff
        },
        stampColor:0xFFFFFF,
    };


    stampConfig:StampConfig = {
        xWays:true,
        xBet:true,
        volatility:Volatility.EXTREME
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];


    public static INTRO_BG = "resources/images/introBackground.jpg";
    private bgBlack:PIXI.Sprite;

    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(PunkRockerIntroConfig.INTRO_BG,PunkRockerIntroConfig.INTRO_BG);
        imgLoader.add(GameAssets.IN_GAME_ARROW,GameAssets.IN_GAME_ARROW); //Needed elsewhere. It was in the intro spritesheet so loading it  here.
        imgLoader.add("feature", "resources/images/intro_feature.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("logo", "resources/images/introLogo.png");
        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();

        this.bgBlack = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.bgBlack.anchor.set(0.5, 0.5);
        this.bgBlack.tint = 0x000000;
        this.bgBlack.alpha = 1;
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture(PunkRockerIntroConfig.INTRO_BG));
        bgSprite.anchor.set(0.5, 0.5);
        bgSprite.scale.set(0.75,0.75);

        this.background.addChild(this.bgBlack);
        this.background.addChild(bgSprite);
        this.borderTop = new PIXI.Container();
        this.borderBottom = new PIXI.Container();
        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        this.pages = [
            new PunkRocker2SlideShowPage(ImgLoader.getImgTexture("feature")),
            new PunkRocker2SlideShowPage(ImgLoader.getImgTexture("feature2"))
        ];
    }

    onResize():void {
        const bounds = NolimitApplication.screenBounds;
        this.bgBlack.width = bounds.width;
        this.bgBlack.height = bounds.height;
    }
}